import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)(({ theme }) => ({
    height: `calc(100% - 48px)`,
    display: "grid",
    gridTemplateRows: "56px 1fr",
    overflow: "hidden",
    background: theme.mode === "light" ? "#f4f7fb" : "#424242",
    border: 0,
}))

export default TicketAdvancedLayout;
